module.exports = __webpack_public_path__ + "static/media/Close Table.ecd7961b.svg";